import { Layers, Mail, MapPin, Phone, Sun, Users } from 'lucide-react'
import { AMBITI_STATS } from '../../data/ambitiStats'
import type { StrutturaDisabilita } from '../../data/struttureDisabilita'
import { StrutturaDetailDialog } from '../StrutturaDetailDialog'

const COLOR = '#10b981'

function fallback(value?: string | number | null) {
  if (value === null || value === undefined) return '—'
  const s = String(value).trim()
  return s.length > 0 ? s : '—'
}

function StatBox({ label, value, color }: { label: string; value: string | number; color: string }) {
  return (
    <div style={{ padding: '10px 14px', borderRadius: 10, background: `${color}08`, border: `1px solid ${color}25` }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 20, fontWeight: 800, color, lineHeight: 1.2 }}>{value}</div>
    </div>
  )
}

function InfoRow({ label, value, icon: Icon }: { label: string; value: React.ReactNode; icon?: React.ComponentType<{ size?: number | string }> }) {
  return (
    <div style={{ display: 'flex', gap: 8, padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
      <dt style={{ fontSize: 12, color: 'var(--text-3)', minWidth: 120, fontWeight: 600 }}>{label}</dt>
      <dd style={{ fontSize: 12, color: 'var(--text-1)', margin: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
        {Icon && <Icon size={13} />}
        {value}
      </dd>
    </div>
  )
}

function CddDetailContent({ struttura }: { struttura: StrutturaDisabilita }) {
  const ambito = AMBITI_STATS.find(a => a.id === struttura.ambitoId)

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 999, color: COLOR, background: `${COLOR}20`, border: `1px solid ${COLOR}40` }}>
          <Sun size={12} /> CDD
        </span>
        {struttura.listaAttesa && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 999, color: '#ef4444', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)' }}>
            <Users size={12} /> Lista d'attesa
          </span>
        )}
        {ambito && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, fontWeight: 600, padding: '4px 12px', borderRadius: 999, color: 'var(--accent-blue)', background: 'hsla(210,100%,56%,0.08)', border: '1px solid hsla(210,100%,56%,0.2)' }}>
            <Layers size={12} /> Ambito di {ambito.nome}
          </span>
        )}
      </div>

      <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text-0)', margin: 0, letterSpacing: '-0.01em' }}>{struttura.nome}</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
        <StatBox label="Posti a contratto" value={struttura.postiContratto} color={COLOR} />
        <StatBox label="Posti disponibili" value={struttura.postiDisponibili} color="#10b981" />
        <StatBox label="Persone in lista" value={struttura.personeInLista} color="#ef4444" />
      </div>

      <dl style={{ margin: 0 }}>
        <InfoRow label="Comune" value={fallback(struttura.comune)} icon={MapPin} />
        <InfoRow label="Indirizzo" value={fallback(struttura.indirizzo)} icon={MapPin} />
        <InfoRow label="Telefono" value={fallback(struttura.telefono)} icon={Phone} />
        <InfoRow label="Email" value={fallback(struttura.email)} icon={Mail} />
      </dl>
    </div>
  )
}

export function CddDialog({ struttura, onClose }: { struttura: StrutturaDisabilita | null; onClose: () => void }) {
  if (!struttura) return null
  return (
    <StrutturaDetailDialog open detailUrl={`/cdd/${struttura.id}`} fromUrl="/cdd" onClose={onClose}>
      <CddDetailContent struttura={struttura} />
    </StrutturaDetailDialog>
  )
}
